import { defineMessages } from "react-intl";

const PASSWORD_UPDATE = "password-update";

const passwordUpdateMessages = defineMessages({
  changeMyPassword: {
    id: `${PASSWORD_UPDATE}.change-my-password`,
    defaultMessage: "Change my password",
    description: "Title for page to change the password"
  }
});

export default passwordUpdateMessages;
